import { render, staticRenderFns } from "./JudgeWriteDefaultLayout.vue?vue&type=template&id=957be472&scoped=true&"
import script from "./JudgeWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./JudgeWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957be472",
  null
  
)

export default component.exports